import React, { useState } from 'react';
import { Modal } from '@vtblife/uikit';

import { AgentFavoritesLikeList } from './AgentFavoritesLikeList/AgentFavoritesLikeList';

interface IAgentFavoritesModalTriggerArgs {
    handleToggle: VoidFunction;
}

interface AgentFavoritesModalProps {
    offerId: string;
    isMyFavorite: boolean;
    renderTrigger: (args: IAgentFavoritesModalTriggerArgs) => React.ReactNode;
    onChangeMyFavorite: (v: boolean) => void;
}

export const AgentFavoritesModal: React.FC<AgentFavoritesModalProps> = ({
    offerId,
    isMyFavorite,
    renderTrigger,
    onChangeMyFavorite,
}) => {
    const [ open, setOpen ] = useState(false);

    return (
        <>
            {renderTrigger({ handleToggle: () => setOpen(! open) })}
            <Modal
                size='s'
                opened={open}
                onClose={() => setOpen(false)}
            >
                <Modal.Content>
                    <AgentFavoritesLikeList
                        offerId={offerId}
                        isMyFavorite={isMyFavorite}
                        fullWidth
                        onChangeMyFavorite={onChangeMyFavorite}
                    />
                </Modal.Content>
            </Modal>
        </>
    );
};
